// 如何使用
// 
// /App.vue

// <template>
//   <div id="app">
//     <router-view />
//     <!-- <audio ref="audio">
//       <source src="@/assets/music/sss.mp3" type="audio/mpeg"/>
//       Your browser does not support the audio element.
//     </audio> -->
//   </div>
// </template>

// import mixin_webSocket from '@/mixins/mixin_webSocket'
// mixins: [mixin_webSocket],
// 

import store from '@/store'

const debugParams = {
  shopId: store.state.shop_x.id,
  type: 2,
  autoOnlyBendRead: true,
}

export default {
  data() {
    return {
      // isPlayMusic: false,
      socket: null,
      // notifyObj: '',
      socketStatus: 0, // 0初始化 1连接中 2连接成功 3连接失败 4连接关闭 5重新连接中
    }
  },
  methods: {
    // 建立webSocket
    webSocket() {
      if (!this.shop_x || !this.shop_x.id) {
        return
      }
      console.log(`%cWebSocket当前状态:`, 'color: #f00;', ['初始化','连接中','连接成功','连接失败','连接关闭','重新连接中'][this.socketStatus])
      if ([1, 2].includes(this.socketStatus)) {
        console.log(`%c连接中or连接成功，无需建立WebSocket`, 'color: #f00;', )
        return
      } else if (typeof (WebSocket) == 'undefined') {
        this.socketStatus = 4
        this.$notify({ title: '提示', message: '當前瀏覽器無法接收實時信息，請使用谷歌瀏覽器！', type: 'warning', duration: 0 })
      } else if (this.user_x.id) {
        try {
          this.socketStatus = 1
          this.initWebSocket()
        } catch(e) {
          this.socketStatus = 4
          console.log(`%cinitWebSocket Error:`, 'color: #f00;', e)
        }
      } else {
        this.socketStatus = 4
        console.log(`%cWebSocket已完全关闭`, 'color: #f00;', )
      }
    },
    initWebSocket() {
      if (!this.shop_x || !this.shop_x.id) {
        return
      }
      // 实例化socket，这里把用户名传给后台，使后台能判断要把消息发给哪个用户，其实也可以后台直接获取用户IP来判断并推送
      const socketUrl = this.$api.url_websocket + this.shop_x.id + '/0'
      this.socket = new WebSocket(socketUrl)

      // let timer = setTimeout(() => {
      //   this.socket.close()
      //   clearTimeout(timer)
      // }, 3000)

      // 监听socket打开
      this.socket.onopen = e => {
        console.log(`%cWebSocket已打开`, 'color: #f00;', e)
        clearInterval(this.timer_ws)
      }
      // 监听socket消息接收
      this.socket.onmessage = msg => {
        console.log(`%cWebSocket接收数据:`, 'color: #f00;', msg)
        if (msg.data === 'success') {
          console.log(`%cWebSocket建立连接成功`, 'color: #f00;', )
          this.socketStatus = 2
          this.heartbeatSetInterval()
        } else {
          let res = JSON.parse(msg.data)
          console.log(`%cWebSocket消息内容:`, 'color: #f00;', res)

          if (res.type === 0) { // 心跳检测
            console.log(`%c心跳检测:`, 'color: #f00;')
            this.heartbeatSetInterval()
          } else if (this.shop_x.id === res.shopId) {
            switch (res.type) {
              case 2:
                // 开关店
                this.shop_x.businessStatus = res.businessStatus
                this.shop_x.controlDay = ''
                this.shop_x_save(this.shop_x)
                break;
              case 3:
                // 带审核订单
                this.menuCount_x.waitingOrderCount = res.count
                this.menuCount_x_save(this.menuCount_x)
  
                if (res.orderAuditIds) {
                  this.bellOrderIds_x_save(res.orderAuditIds)
                } else if (res.newAuditOrder) {
                  // this.$emit('playMusic')
                  this.bellRing_x_save(true)
                } else if (res.count === 0) {
                  this.bellRing_x_save(false)
                }
                break;
              case 4:
                // 队列
                console.log(`%c队列ws:`, 'color: #00f;', res.lineUpCodeResponseList)
                this.menuCount_x.lineUpCodeResponseList = res.lineUpCodeResponseList
                this.menuCount_x_save(this.menuCount_x)
                break;
              case 5:
                // 全局场景变动
                console.log(`%c手动控制场景ws:`, 'color: #00f;', res)
                this.getShopData()
                this.getCurrentScene()
                break;
            
              default:
                break;
            }
          }
        }
      }
      // 监听socket错误
      this.socket.onerror = e => {
        console.log(`%cWebSocket服务器错误:`, 'color: #f00;', e)
        this.socketStatus = 3
        // this.reconnect()
        this.$api.debug({ ...debugParams, desc: 'WebSocket服务器错误' })
      }
      // 监听socket关闭
      this.socket.onclose = e => {
        console.log(`%cWebSocket已关闭:`, 'color: #f00;', e)
        this.socketStatus = 4
        // this.reconnect()
        this.$api.debug({ ...debugParams, desc: 'WebSocket已关闭' })
      }
    },
    heartbeatSetInterval() {
      clearInterval(this.timer_ws)
      this.timer_ws = null
      this.timer_ws = setInterval(() => {
        console.log(`%c心跳检测结束一分钟，开始尝试进行关闭并重连:`, 'color: #f00;')
        try {
          this.socket.close()
          this.reconnect()
          this.$api.debug({ ...debugParams, desc: 'WebSocket心跳失败时，尝试进行关闭并重连成功' })
          console.log(`%cWebSocket心跳失败时，尝试进行关闭并重连成功`, 'color: #f00;')
        } catch (error) {
          this.$api.debug({ ...debugParams, desc: 'WebSocket心跳失败时，尝试进行关闭并重连失败' })
          console.log(`%cWebSocket心跳失败时，尝试进行关闭并重连失败`, 'color: #f00;')
        }
      }, 60000)
    },
    reconnect() {
      if (this.socketStatus === 5) return
      this.socketStatus = 5
      this.webSocket()
      // let timer = setTimeout(() => {
      //   this.socketStatus = 5
      //   this.webSocket()
      //   clearTimeout(timer)
      // }, 1000)
    },
    closeWs() {
      this.socket.close()
      clearInterval(this.timer_ws)
      this.socketStatus = 0
    }
  },
  // created() {
  //   // 判断是否PC端
  //   // if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
  //   // } else {
  //     // 判断是否登录
  //     // if (this.userInfo && this.userInfo.id) {
  //       // 指定不监听的页面
  //       // if (window.location.hash.indexOf('#/print') !== 0) {
  //         this.webSocket()

  //         this.$alert('开启音频播放权限', '提示', {
  //           confirmButtonText: '确定',
  //           callback: action => {
  //             this.$notify.success({
  //               title: '成功',
  //               message: '已开启音频权限',
  //               duration: 1000,
  //             })
  //           }
  //         })
  //       // }
  //     // }
  //   // }
  // },
  // beforeRouteLeave(to, from, next) {
  //   console.log(`%cthis.socket:`, 'color: #f0f;', this.socket)
  //   this.socket && this.socket.close()
  //   next()
  // },
}